import { useState } from 'react';
import { usePlans } from '@/hooks/usePlans';
import { useHighlights } from '@/hooks/useHighlights';
import { ComparatorCard, RadioGroup } from '@/components/molecules';
import { PLAN_TYPES, type PlanType } from '@/config/api';
import arrowRight from '@/assets/icons/arrow-right.svg';
import './BestOffers.scss';

const DISPLAY_COUNT = 4;

const TAB_CONFIG = {
  [PLAN_TYPES.MOBILE]: {
    label: 'Forfaits Mobile',
    ctaLabel: 'Comparez tous les forfaits mobile',
    ctaHref: '/forfaits-mobiles-comparateur/',
  },
  [PLAN_TYPES.INTERNET]: {
    label: 'Box Internet',
    ctaLabel: 'Comparez toutes les box internet',
    ctaHref: '/comparateur/',
  },
} as const;

function getMonthYear(): string {
  return new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
}

export function BestOffers() {
  const [activeTab, setActiveTab] = useState<PlanType>(PLAN_TYPES.MOBILE);

  const { plans: mobilePlans, loading: mobileLoading } = usePlans(PLAN_TYPES.MOBILE);
  const { plans: internetPlans, loading: internetLoading } = usePlans(PLAN_TYPES.INTERNET);

  const activePlans = activeTab === PLAN_TYPES.MOBILE ? mobilePlans : internetPlans;
  const loading = activeTab === PLAN_TYPES.MOBILE ? mobileLoading : internetLoading;

  const topPlans = activePlans.slice(0, DISPLAY_COUNT);
  const plansWithHighlights = useHighlights(topPlans, { planType: activeTab });

  const config = TAB_CONFIG[activeTab];

  if (loading) return null;

  return (
    <section className="best-offers">
      <h2 className="best-offers__title">
        Les meilleures offres Box et Mobile de {getMonthYear()}
      </h2>

      <div className="best-offers__header">
        <RadioGroup
          name="best-offers-type"
          options={[
            { value: PLAN_TYPES.MOBILE, label: 'Forfaits Mobile' },
            { value: PLAN_TYPES.INTERNET, label: 'Box Internet' },
          ]}
          value={activeTab}
          onChange={(value) => setActiveTab(value as PlanType)}
        />

        <a href={config.ctaHref} className="best-offers__cta">
          {config.ctaLabel}
          <img src={arrowRight} alt="" aria-hidden="true" width={16} height={16} />
        </a>
      </div>

      <div className="best-offers__grid" role="tabpanel">
        {plansWithHighlights.map((plan, index) => (
          <ComparatorCard
            key={plan.id}
            plan={plan}
            position={index + 1}
            planType={activeTab}
          />
        ))}
      </div>
    </section>
  );
}

export default BestOffers;
